
import { UserProfile } from '@/types/users';
import Vue from 'vue'

export default Vue.extend({
  name: 'HelpScout',
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data: () => ({
    timeoutTimer: null as NodeJS.Timeout | null
  }),
  mounted () {
    // this line is copy pasted from the helpshout webpage
    // @ts-ignore
    // eslint-disable-next-line
    !function(e,t,n){function a(){var e=t.getElementsByTagName("script")[0],n=t.createElement("script");n.type="text/javascript",n.async=!0,n.src="https://beacon-v2.helpscout.net",e.parentNode.insertBefore(n,e)}if(e.Beacon=n=function(t,n,a){e.Beacon.readyQueue.push({method:t,options:n,data:a})},n.readyQueue=[],"complete"===t.readyState)return a();e.attachEvent?e.attachEvent("onload",a):e.addEventListener("load",a,!1)}(window,document,window.Beacon||function(){});
    this.setBeaconId()
  },
  beforeDestroy () {
    this.cleanUp()
  },
  render () {
    return null as any
  },
  computed: {
    userProfile (): UserProfile|null {
      return this.$store.direct.state.user.profile
    },
    teamName (): string {
      return this.$store.direct.state.team.team.name
    }
  },
  watch: {
    id (newVal: string) {
      // @ts-ignore
      if (window.Beacon) {
        // @ts-ignore
        // eslint-disable-next-line new-cap
        window.Beacon('destroy')
        // @ts-ignore
        // eslint-disable-next-line new-cap
        window.Beacon('init', newVal)
        this.setBeaconIdentify()
      }
    }
  },
  methods: {
    setBeaconIdentify () {
        let name = this.userProfile?.first_name ?? ''
        name += ' ' + this.userProfile?.last_name ?? ''
        const displayName = this.userProfile?.display_name
        if (displayName !== undefined)
          name += ' (' + displayName + ')'
        const identify = {
          name:  name,
          email: this.userProfile?.email,
          company: this.teamName
        }
        // @ts-ignore
        // eslint-disable-next-line new-cap
        Beacon('identify', identify)
    },
    setBeaconId () {
      this.cleanUp()
      this.timeoutTimer = setTimeout(() => {
        // @ts-ignore
        // eslint-disable-next-line new-cap
        window.Beacon('init', this.id)
        this.setBeaconIdentify()
      }, 2000)
    },
    cleanUp () {
      if (this.timeoutTimer) {
        clearTimeout(this.timeoutTimer)
      }
      // @ts-ignore
      // eslint-disable-next-line new-cap
      window.Beacon('destroy')
    }
  }
})
